import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import logo from "../../img/ty.gif";
import { fetchReport } from "../../scoreservice";
import "./thankyou.css";


const STAGE = 5;

function Thankyou({ updateHeader }) {
   useEffect(() => {
        updateHeader({ backButtonRedirect: "/thankyou" });


    }, []); // run once on mount
  const navigate = useNavigate();

  const userData = JSON.parse(sessionStorage.getItem("userData") || "{}");

  const [initialTime, setInitialTime] = useState("00:00");
  const [ready, setReady] = useState(false);
  const [totalScore, setTotalScore] = useState(0);




  /* FETCH FINAL TIME */
  useEffect(() => {
    const loadStageData = async () => {
      if (!userData?.userId) {
        setReady(true);
        return;
      }

      try {
        const res = await fetchReport({
          userId: userData.userId,
          sessionId: userData.sessionId,
          organizationId: userData.organizationId,
          stage: STAGE,
        });


        if (res?.status === "success") {
          setInitialTime(res.time || "00:00");
               setTotalScore(res.total_score || 0); // ✅ ADD THIS
        }
      } catch (err) {
        console.error("Thankyou fetch failed", err);
      } finally {
        setReady(true);
      }
    };

    loadStageData();
  }, []); // ✅ empty deps → runs once

  return (
    <div className="intro-page-bg">
      <div className="intro-main-container" style={{ textAlign: "center" }}>
        <div className="intro-main-container1">
          <img src={logo} alt="Thank You" className="ty-logo" />
        </div>

        <div className="text-main-container">
          {/* <h4 id="ty-text">
            Your Score is {ready ? totalScore : 0}  in{" "}
            {ready ? initialTime : "00:00"} minutes.
          </h4> */}

            <h4 id="ty-text">
           Mission accomplished! You retrieved the newly designed Indian currency plates in{" "} 
            {ready ? initialTime : "00:00"} minutes.
          </h4>
        </div>
      </div>
    </div>
  );
}

export default Thankyou;
